import type { PublicPluginAPI } from '@atlaskit/editor-common/types/next-editor-plugin';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/useSharedPluginStateSelector';
import type { SyncedBlockPlugin } from '@atlaskit/editor-plugin-synced-block/synced-block-plugin-type';

export type EditorPresetAPI = PublicPluginAPI<[SyncedBlockPlugin]> | null | undefined;

export const useSharedSyncBlockState = (
	api: EditorPresetAPI,
): {
	hasUnsavedBodiedSyncBlockChanges: boolean;
} => {
	const hasUnsavedBodiedSyncBlockChanges =
		(useSharedPluginStateSelector(api, 'syncedBlock.hasUnsavedBodiedSyncBlockChanges' as never, {
			disabled: !api,
		}) as boolean | undefined) ?? false;

	return { hasUnsavedBodiedSyncBlockChanges };
};
